import React, { useEffect } from 'react'
import { AboutWrapper,MobileViewImageWrap, DestopViewImageWrap } from "./About.style"

export const About = () => {

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])
  return (
    <AboutWrapper>

      <h1>The Finest Journey to Financial Freedom</h1>
      <p style={{fontStyle:"italic"}}>
          A Holistic Solution to Amazing savings and investment 
          spree all through our well outlined savings and investment
          plans designed to ensure a guaranteed future for the African
          Children and the unborn generations,  and also to enable the gen z, 
          millennials and the aged become prosperous by building up for themselves 
          substantial wealth via Financial literacy on our platform.
      </p>
      <p>
          Our mission is to basically help parents provide security 
          for the future of the African Children and the unborn generations,
          it goes beyond just helping them cultivate  a savings discipline 
          to easily hit target savings for their children but to solve the 
          problem of poverty, financial instability and unemployment among our 
          future youths/graduate through the provision of an already made available 
          fund so they can achieve future desired goals with ease or become stakeholders 
          in the emerging African economy and the world at large.

      </p>
      <DestopViewImageWrap>
        <img src="img/Rectangle 746.jpg" alt="hand shake" />
      </DestopViewImageWrap>
      <MobileViewImageWrap>
        <img src="img/Rectangle 747.jpg" alt="hand shake" />
      </MobileViewImageWrap>
      <p>
          We hope to raise a new generation of a prosperous African 
          children while building a great continent, Inclusively we are 
          helping the African young population and everyone to understand money
          management so they can be able to manage their finances and easily build 
          up wealth for themselves by making savings and investment fun, easily hitting 
          target goals seamlessly possible and worth it.We are on a journey 
          to holistically groom a new prosperous African people Irrespective of age 
          and gender, we welcome all and sundry on this Amazing journey as we work 
          together to bring this dream into a reality.
      </p>
    </AboutWrapper>
  )
}

